<template>
    <kt-row>
        <kt-col xs="12" md="6">
            <deposit-info :deposit="form_data" v-if="status !== 'loading'"></deposit-info>
        </kt-col>
        <kt-col xs="12" md="6">
            <deposit-setting></deposit-setting>
            <deposit-limits-settings v-if="status !== 'loading'" :deposit="form_data"></deposit-limits-settings>
        </kt-col>
    </kt-row>
</template>

<script>
import {mapGetters} from 'vuex'
import depositSetting from './deposit-setting'
import depositInfo from './deposit-info'
import depositLimitsSettings from './deposit-limits-settings'

export default {
    components: {
        depositSetting,
        depositInfo,
        depositLimitsSettings,
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        ...mapGetters('deposit', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid,
        }
    },
    mounted() {
        this.$store.dispatch('deposit/adminFind', {hashid : this.hashid, is_starshop : this.gatewaySource === 'starshop'})
    },
}
</script>

<style>
@media (min-width: 768px) {
    #ivr-info > div > :first-child {
        border-left: 1px solid #ddd;
    }
}
</style>